import { Button } from '@/ui-kit';
import styles from './button-submit-step.module.scss';
import clsx from 'clsx';
import { callYaMetrika } from '@/utils/call-ya-metrika';
interface Props {
    isLoading?: boolean;
    stepNumber: number;
    href?: string;
    isDisabled?: boolean;
    isGray?: boolean;
    title?: string;
    onClick?: () => void;
}

export const ButtonSubmitStep: React.FC<Props> = ({
    stepNumber = 1,
    isLoading,
    href,
    isDisabled,
    isGray,
    title = 'Дальше',
    onClick,
}) => {

    return (
        <div className={clsx(styles.wrapperButtonStep, isGray && styles.gray)}>
            <Button
                type="submit"
                variant="stretched"
                typeColor="orange"
                isLoading={isLoading}
                isDisabled={isDisabled}
                isLink={!!href}
                to={href}
                onClick={() => onClick?.()}>
                {title}
            </Button>
        </div>
    );
};
